import React from "react";
import { Link } from "react-router-dom";
import { AdminURL } from "../../routes/admin_routes/AdminURL";

const AdminDashboard = () => {
    return(
        <>
            <h1>This is Admin Dashboard</h1>
            <Link to={AdminURL.ADMIN_USERS}>Show all user</Link>
        </>
    );
};

export default AdminDashboard;
